/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var receipt = "";
  $on('pageInit', function () {
    for (var i = 0; i < 20; i++) {
      var data = localStorage.getItem("web" + i);

      if (data != "" && data != undefined && data != "null") {
        var data = JSON.parse(data);
        receipt += "\n            <tr>\n              <td class=\"label-cell\">" + data.orderId + "</td>\n              <td class=\"label-cell\"><button class=\"button button-fill button-view\" id=\"" + i + "\">view</button></td>\n            </tr>\n        ";
        $update();
      }

      $(document).on("click", ".button-view", function (e) {
        window.web_data = localStorage.getItem("web" + e.srcElement.id);
        window.origin = "history";
        $f7.views.current.router.navigate("/web_qr/", {
          force: true
        });
      });
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">GD Lotaria</div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">History</div>
    <div class="block">
      Previous booking details
    </div>






    <div class="block-title">
      <span class='en'>Search Result</span>
      <span class='cn'>搜索结果</span>
      <span class='tl'>Buka rezultado</span>
    </div>
    <div class="card data-table">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Order ID</th>
            <th class="numeric-cell">Action</th>
          </tr>
        </thead>
        <tbody innerHTML=${receipt}>

        </tbody>
      </table>
    </div>

  </div>
</div>
`
    }
    ;
}

framework7Component.id = 'b27c4c5888';
export default framework7Component;